// Internationalization content for TVCabSat
// Supported: PT (default), EN, ES

export const LANGS = [
  { code: "pt", label: "PT", name: "Português", flag: "🇵🇹" },
  { code: "en", label: "EN", name: "English", flag: "🇬🇧" },
  { code: "es", label: "ES", name: "Español", flag: "🇪🇸" },
];

export const translations = {
  pt: {
    nav: {
      about: "Sobre",
      equipment: "Equipamentos",
      infrastructure: "Infra-estruturas",
      portfolio: "Portefólio",
      services: "Serviços",
      partners: "Parceiros",
      whyus: "Porquê Nós",
      contact: "Contactos",
      careers: "Carreiras",
      cta: "Fale Connosco",
      catalog: "Catálogo",
    },
    hero: {
      overline: "Empresa de Direito Angolano · 🇦🇴",
      title_line1: "Telecomunicações,",
      title_line2: "Informática &",
      title_line3: "Satélite.",
      subtitle:
        "Especialistas em soluções de Sistemas e Equipamentos de Telecomunicações e Informática — VSAT, Wireless, TV por Cabo e Satélite, Vigilância e Redes.",
      primary_cta: "Solicitar Orçamento",
      secondary_cta: "Ver Serviços",
      live_status: "Equipa técnica em serviço",
    },
    about: {
      overline: "Sobre a TVCabSat",
      title: "Tecnologia, fiabilidade e equipa em Angola.",
      body_1:
        "A TVCABSAT, Lda é uma empresa angolana que se destaca na oferta de soluções avançadas em Sistemas e Equipamentos de Telecomunicações e Informática. Com uma infraestrutura tecnológica robusta, somos especializados em:",
      specialties: [
        {
          title: "Soluções VSAT",
          desc: "Banda Ku, Banda Ka e Banda C, impulsionadas pelo satélite angolano ANGOSAT-2.",
        },
        {
          title: "TV por Cabo e Satélite",
          desc: "Serviços de alta qualidade e confiabilidade.",
        },
        {
          title: "Equipamentos de Vigilância",
          desc: "Sistemas de CCTV e segurança para protecção eficaz.",
        },
        {
          title: "Telefones Satélites e Convencionais",
          desc: "Soluções de comunicação versáteis.",
        },
        {
          title: "Centrais e Redes Telefónicas",
          desc: "Centrais analógicas e digitais, além de redes de dados.",
        },
        {
          title: "Manutenção e Implantação de Torres de Telecomunicações",
          desc: "Construção, instalação e manutenção de torres autoportantes, estaiadas e mastros em todo o território angolano.",
        },
      ],
      body_2:
        "Representamos e comercializamos equipamentos de marcas globalmente reconhecidas pela sua confiabilidade, incluindo rádios e repetidores MOTOROLA e HYTERA, centrais telefónicas digitais e analógicas INTELBRAS, além de sistemas de recepção de televisão DSTV. A nossa equipa é altamente capacitada para montagem e assistência técnica, garantindo a satisfação e segurança dos nossos clientes.",
      clientes_title: "Clientes",
      clientes_body:
        "Os nossos clientes incluem instituições do Estado, a Embaixada dos Estados Unidos e outras no país, e empresas de serviços para as petrolíferas em Angola. Fornecemos equipamentos de rádio UHF/VHF com certificação contra explosões dos grupos IIA e IIC, adequados para ambientes rigorosos que incluem gases como hidrogénio e acetileno. Isto reflecte a nossa capacidade de atender a demandas exigentes e de alta complexidade.",
      stat_team: "Funcionários",
      stat_team_desc: "Equipa multidisciplinar ao seu serviço",
      stat_years: "Anos",
      stat_years_desc: "De operação no mercado angolano",
      stat_brands: "Marcas",
      stat_brands_desc: "Parceiros internacionais representados",
    },
    services: {
      overline: "O Que Fazemos",
      title: "Seis áreas. Uma equipa. Execução integral.",
      subtitle:
        "Da engenharia à manutenção, a TVCabSat actua em todas as camadas de conectividade e tecnologia.",
      assistance: {
        title: "Assistência Técnica",
        desc: "Manutenção preventiva e correctiva para toda a infra-estrutura crítica.",
        items: [
          "Sistemas DSTV",
          "Redes de Telecomunicações",
          "Centrais Telefónicas",
          "VSATs",
          "Sistemas de Informática",
        ],
      },
      television: {
        title: "Monitores HD",
        desc: "Do monitor ao condomínio — sinal limpo, instalação profissional.",
        items: [
          "Comercialização de Monitores LED e LCD",
          "Montagem de Sistemas DSTV",
          "Distribuição de Sinal TV para Condomínios",
        ],
      },
      communications: {
        title: "Comunicações",
        desc: "Rádio, telefonia e comunicações via satélite para operações exigentes.",
        items: [
          "Rádios e Repetidores MOTOROLA",
          "Centrais Telefónicas INTELBRAS e ALCATEL",
          "VSATs",
        ],
      },
      it: {
        title: "Informática",
        desc: "Redes estruturadas, wireless e computadores — prontos a produzir.",
        items: [
          "Comercialização de Computadores",
          "Sistemas Wireless para Dados e Internet",
          "Instalação de Redes Estruturadas",
        ],
      },
      towers: {
        title: "Torres de Telecomunicações",
        desc: "Instalação, construção e manutenção de torres de telecomunicações por equipas especializadas — projecto chave-na-mão dos 6 aos 30 metros.",
        items: [
          "Instalação e construção de torres treliçadas",
          "Manutenção preventiva e correctiva",
          "Mastros galvanizados de 6m a 12m",
          "Torres autoportantes e estaiadas de 15m a 30m",
          "Bases em betão armado e ancoragens",
        ],
      },
      security: {
        title: "Segurança & CCTV",
        desc: "Sistemas eletrónicos de monitorização — a espinha dorsal da segurança moderna.",
        items: [
          "Câmaras analógicas e IP",
          "Reconhecimento facial e leitura de matrículas (IA)",
          "Gravação NVR / DVR contínua",
          "Monitorização remota em tempo real",
        ],
      },
    },
    partners: {
      overline: "Marcas Representadas",
      title: "Equipamentos internacionais de fiabilidade comprovada.",
    },
    whyus: {
      overline: "Porquê a TVCabSat",
      title: "Qualidade, eficiência e compromisso.",
      subtitle:
        "Com a nossa equipa de 40 funcionários, pretendemos ser úteis na execução de qualquer contrato celebrado ou futuramente a celebrar.",
      points: [
        {
          title: "Fiabilidade",
          desc: "Marcas e processos certificados. Soluções que ficam de pé.",
        },
        {
          title: "Equipa Especializada",
          desc: "40 profissionais em engenharia, instalação e assistência.",
        },
        {
          title: "Cobertura Integral",
          desc: "Do projecto à manutenção — um único interlocutor.",
        },
        {
          title: "Presença Nacional",
          desc: "Sediados em Luanda, com capacidade de actuação em todo o país.",
        },
      ],
    },
    contact: {
      overline: "Fale Connosco",
      title: "Vamos conversar sobre o seu contacto e Projecto de que necessita.",
      subtitle:
        "Envie-nos uma mensagem ou ligue directamente. Respondemos em horário comercial.",
      address_label: "Endereço",
      address_value: "Rua Padre Manuel Ruela Pombo, 40 · R/C e 3º andar · Maianga · Luanda · Angola",
      phone_label: "Telefones Recepção",
      office_phones: "Escritório: +244 222 352 949 · +244 222 352 922",
      mobile_phone: "Celular: +244 925 687 036",
      hours_label: "Horário",
      hours_value: "Seg — Sex · 08h00 às 17h00",
      commercial_title: "Desenvolvimento de Negócios",
      finance_title: "Contactos Administrativo e Finanças",
      direction_title: "Contactos de Direcção",
      area_comercial_title: "Área Comercial",
      support_title: "Suporte Técnico",
      cta_banner_title: "Podemos ajudar com qualquer um dos seus projetos.",
      cta_banner_desc: "Da análise à instalação — fale connosco e a nossa equipa desenha a solução certa para si.",
      dopamine_title_pre: "Vamos construir algo",
      dopamine_title_highlight: "extraordinário",
      dopamine_title_post: "juntos.",
      dopamine_subtitle:
        "Resposta em menos de 24 horas úteis · 100% garantia oficial · Cobertura nacional.",
      dopamine_call_label: "Ligar agora",
      dopamine_email_label: "Enviar email",
      dopamine_whatsapp_label: "WhatsApp",
      dopamine_quick_links: "Ligações rápidas",
      commercial_phone_label: "Tel.",
      commercial_email_label: "Email",
      commercial_list: [
        {
          name: "Dércio Mancoca",
          role: "Responsável de Desenvolvimento de Negócios",
          phone: "+244 923 269 030",
          phone_href: "+244923269030",
          phones: [
            { label: "+244 923 269 030", href: "+244923269030" },
            { label: "+244 925 687 036", href: "+244925687036" },
          ],
          emails: [
            "dercio.mancoca@tvcabsat.ao",
          ],
        },
      ],
      finance_list: [
        {
          name: "Paula Martins",
          role: "Responsável pela Área Financeira",
          phone: "+244 929 100 486",
          phone_href: "+244929100486",
          emails: [
            "paula.martins@tvcabsat.ao",
            "financas@tvcabsat.ao",
          ],
        },
      ],
      direction_list: [
        {
          name: "Duarte Nuno Martins",
          role: "CEO",
          phones: [],
          emails: [
            "d.nuno@tvcabsat.ao",
            "administracao@tvcabsat.ao",
          ],
        },
      ],
      area_comercial_list: [
        {
          name: "Equipa Comercial",
          role: "Vendas e atendimento ao cliente",
          phone: "+244 925 687 036",
          phone_href: "+244925687036",
          emails: ["comercial@tvcabsat.ao"],
        },
      ],
      support_list: [
        {
          name: "Luanda Suporte Técnico",
          role: "Suporte técnico — Luanda",
          phone: "+244 938 926 564",
          phone_href: "+244938926564",
          emails: ["suporte@tvcabsat.ao"],
        },
        {
          name: "Soyo Suporte e Comercial",
          role: "Suporte técnico e comercial — Soyo",
          phone: "+244 976 665 377/378",
          phone_href: "+244976665378",
          phones: [
            { label: "+244 976 665 377/378", href: "+244976665378" },
          ],
          emails: ["suporte@tvcabsat.ao"],
        },
      ],
      commercial_name: "Paula Martins",
      commercial_role: "Responsável pela Área Comercial",
      commercial_phone: "+244 929 100 486",
      form: {
        name: "Nome",
        name_ph: "O seu nome",
        email: "Email",
        email_ph: "email@exemplo.com",
        phone: "Telefone",
        phone_ph: "923 000 000",
        phone_invalid: "Número de telefone inválido para o país selecionado.",
        subject: "Assunto",
        subject_ph: "Selecione um assunto",
        subject_options: {
          commercial_luanda: "Departamento Comercial — Luanda",
          commercial_soyo: "Departamento Comercial — Soyo",
          support_luanda: "Assistência Técnica — Luanda",
          support_soyo: "Assistência Técnica — Soyo",
          finance: "Departamento Administrativo e Finanças",
          job: "Recursos Humanos · Venha trabalhar connosco",
          partnership: "Parceria Local",
        },
        job_notice: "Para se candidatar, preencha o formulário de candidato:",
        job_link: "Preencha Candidatura →",
        message: "Mensagem",
        message_ph: "Descreva o seu pedido…",
        submit: "Enviar mensagem",
        sending: "A enviar...",
        success: "Mensagem enviada. Entraremos em contacto brevemente.",
        error: "Não foi possível enviar. Tente novamente ou contacte-nos por telefone.",
        required: "Preencha os campos obrigatórios.",
      },
    },
    footer: {
      tagline:
        "Empresa de direito angolano · Telecomunicações, Informática, TV & Satélite.",
      rights: "Todos os direitos reservados.",
      nav_title: "Navegação",
      services_title: "Serviços",
      contact_title: "Contactos",
      group_title: "Empresas Grupo TVCabsat",
      group_dauag_desc: "Diamantes, ouro e prata · Prospeção e exploração",
      group_wesa_desc: "Internet na ponta do seu dedo",
    },
  },
  en: {
    nav: {
      about: "About",
      equipment: "Equipment",
      infrastructure: "Infrastructure",
      portfolio: "Portfolio",
      services: "Services",
      partners: "Partners",
      whyus: "Why Us",
      contact: "Contact",
      careers: "Careers",
      cta: "Get in touch",
      catalog: "Catalog",
    },
    hero: {
      overline: "An Angolan Company · 🇦🇴",
      title_line1: "Telecom,",
      title_line2: "IT &",
      title_line3: "Satellite.",
      subtitle:
        "Specialists in Telecom and IT systems — VSAT, Wireless, Cable & Satellite TV, Security, Telephony and Data networks.",
      primary_cta: "Request a Quote",
      secondary_cta: "See Services",
      live_status: "Field team on duty",
    },
    about: {
      overline: "About TVCabSat",
      title: "Technology, reliability and a team based in Angola.",
      body_1:
        "TVCABSAT, Lda is an Angolan company that stands out in delivering advanced solutions in Telecommunications and IT Systems and Equipment. Backed by a robust technological infrastructure, we specialize in:",
      specialties: [
        {
          title: "VSAT Solutions",
          desc: "Ku-band, Ka-band and C-band, powered by the Angolan satellite ANGOSAT-2.",
        },
        {
          title: "Cable and Satellite TV",
          desc: "High-quality and reliable services.",
        },
        {
          title: "Surveillance Equipment",
          desc: "CCTV and security systems for effective protection.",
        },
        {
          title: "Satellite and Conventional Phones",
          desc: "Versatile communication solutions.",
        },
        {
          title: "PBX and Telephony Networks",
          desc: "Analog and digital PBX, plus data networks.",
        },
        {
          title: "Maintenance and Deployment of Telecom Towers",
          desc: "Construction, installation and maintenance of self-supporting and guyed towers and masts across Angola.",
        },
      ],
      body_2:
        "We represent and sell equipment from globally trusted brands, including MOTOROLA and HYTERA radios and repeaters, INTELBRAS digital and analog PBX, as well as DSTV television reception systems. Our team is highly skilled in installation and technical support, ensuring the satisfaction and safety of our customers.",
      clientes_title: "Customers",
      clientes_body:
        "Our customers include State institutions, the United States Embassy and other diplomatic missions in the country, as well as service companies operating for oil-and-gas operators in Angola. We supply UHF/VHF radio equipment with explosion-proof certification in groups IIA and IIC, suitable for harsh environments containing gases such as hydrogen and acetylene — reflecting our ability to meet demanding, high-complexity requirements.",
      stat_team: "Employees",
      stat_team_desc: "A multidisciplinary team at your service",
      stat_years: "Years",
      stat_years_desc: "Operating in the Angolan market",
      stat_brands: "Brands",
      stat_brands_desc: "International partners represented",
    },
    services: {
      overline: "What We Do",
      title: "Six domains. One team. Full-stack delivery.",
      subtitle:
        "From engineering to maintenance, TVCabSat operates across every layer of connectivity and technology.",
      assistance: {
        title: "Technical Assistance",
        desc: "Preventive and corrective maintenance for your critical infrastructure.",
        items: [
          "DSTV Systems",
          "Telecom Networks",
          "PBX Systems",
          "VSATs",
          "IT Systems",
        ],
      },
      television: {
        title: "Monitores HD",
        desc: "From the LED/LCD monitor to the building — clean signal, professional install.",
        items: [
          "LED & LCD Monitor Sales",
          "DSTV Systems Installation",
          "TV Signal Distribution for Condominiums",
        ],
      },
      communications: {
        title: "Communications",
        desc: "Radio, telephony and satellite comms for demanding operations.",
        items: [
          "MOTOROLA Radios & Repeaters",
          "INTELBRAS and ALCATEL PBX",
          "VSATs",
        ],
      },
      it: {
        title: "IT",
        desc: "Structured cabling, wireless and computers — ready to work.",
        items: [
          "Computer Sales",
          "Wireless Systems for Data & Internet",
          "Structured Network Installation",
        ],
      },
      towers: {
        title: "Telecom Towers",
        desc: "Installation, construction and maintenance of telecom towers by specialised crews — turn-key projects from 6 to 30 metres.",
        items: [
          "Installation and build of lattice towers",
          "Preventive and corrective maintenance",
          "Galvanised masts from 6m to 12m",
          "Self-supporting and guyed towers from 15m to 30m",
          "Reinforced concrete bases and anchoring",
        ],
      },
      security: {
        title: "Security & CCTV",
        desc: "Electronic monitoring systems — the backbone of modern security.",
        items: [
          "Analog and IP cameras",
          "Facial recognition and licence-plate reading (AI)",
          "Continuous NVR / DVR recording",
          "Real-time remote monitoring",
        ],
      },
    },
    partners: {
      overline: "Brands We Represent",
      title: "Internationally trusted equipment, field-proven reliability.",
    },
    whyus: {
      overline: "Why TVCabSat",
      title: "Quality, efficiency and commitment.",
      subtitle:
        "With our 40-person team, we aim to be useful in the execution of every contract — signed or yet to come.",
      points: [
        {
          title: "Reliability",
          desc: "Certified brands and processes. Solutions that stand the test of time.",
        },
        {
          title: "Specialized Team",
          desc: "40 professionals in engineering, installation and support.",
        },
        {
          title: "End-to-end Coverage",
          desc: "From design to maintenance — a single point of contact.",
        },
        {
          title: "National Presence",
          desc: "Based in Luanda with capacity to operate across the country.",
        },
      ],
    },
    contact: {
      overline: "Get in Touch",
      title: "Let's talk about your enquiry and the project you need.",
      subtitle:
        "Send us a message or call directly. We reply during business hours.",
      address_label: "Address",
      address_value: "Rua Padre Manuel Ruela Pombo, 40 · RC and 3rd floor · Maianga · Luanda · Angola",
      phone_label: "Reception Phones",
      office_phones: "Office: +244 222 352 949 · +244 222 352 922",
      mobile_phone: "Mobile: +244 925 687 036",
      hours_label: "Hours",
      hours_value: "Mon — Fri · 08:00 to 17:00",
      commercial_title: "Business Development",
      finance_title: "Administrative & Finance Contacts",
      direction_title: "Management Contacts",
      area_comercial_title: "Sales Department",
      support_title: "Technical Support",
      cta_banner_title: "We can help with any of your projects.",
      cta_banner_desc: "From analysis to installation — talk to us and our team will design the right solution for you.",
      dopamine_title_pre: "Let's build something",
      dopamine_title_highlight: "extraordinary",
      dopamine_title_post: "together.",
      dopamine_subtitle:
        "Reply in under 24 business hours · 100% official warranty · Nationwide coverage.",
      dopamine_call_label: "Call now",
      dopamine_email_label: "Send email",
      dopamine_whatsapp_label: "WhatsApp",
      dopamine_quick_links: "Quick links",
      commercial_phone_label: "Phone",
      commercial_email_label: "Email",
      commercial_list: [
        {
          name: "Dércio Mancoca",
          role: "Head of Business Development",
          phone: "+244 923 269 030",
          phone_href: "+244923269030",
          phones: [
            { label: "+244 923 269 030", href: "+244923269030" },
            { label: "+244 925 687 036", href: "+244925687036" },
          ],
          emails: [
            "dercio.mancoca@tvcabsat.ao",
          ],
        },
      ],
      finance_list: [
        {
          name: "Paula Martins",
          role: "Head of Finance",
          phone: "+244 929 100 486",
          phone_href: "+244929100486",
          emails: [
            "paula.martins@tvcabsat.ao",
            "financas@tvcabsat.ao",
          ],
        },
      ],
      direction_list: [
        {
          name: "Duarte Nuno Martins",
          role: "CEO",
          phones: [],
          emails: [
            "d.nuno@tvcabsat.ao",
            "administracao@tvcabsat.ao",
          ],
        },
      ],
      area_comercial_list: [
        {
          name: "Sales Team",
          role: "Sales and customer service",
          phone: "+244 925 687 036",
          phone_href: "+244925687036",
          emails: ["comercial@tvcabsat.ao"],
        },
      ],
      support_list: [
        {
          name: "Luanda Technical Support",
          role: "Technical support — Luanda",
          phone: "+244 938 926 564",
          phone_href: "+244938926564",
          emails: ["suporte@tvcabsat.ao"],
        },
        {
          name: "Soyo Support & Sales",
          role: "Technical support and sales — Soyo",
          phone: "+244 976 665 377/378",
          phone_href: "+244976665378",
          phones: [
            { label: "+244 976 665 377/378", href: "+244976665378" },
          ],
          emails: ["suporte@tvcabsat.ao"],
        },
      ],
      commercial_name: "Paula Martins",
      commercial_role: "Head of Sales",
      commercial_phone: "+244 929 100 486",
      form: {
        name: "Name",
        name_ph: "Your name",
        email: "Email",
        email_ph: "email@example.com",
        phone: "Phone",
        phone_ph: "923 000 000",
        phone_invalid: "Phone number is invalid for the selected country.",
        subject: "Subject",
        subject_ph: "Select a subject",
        subject_options: {
          commercial_luanda: "Commercial Department — Luanda",
          commercial_soyo: "Commercial Department — Soyo",
          support_luanda: "Technical Support — Luanda",
          support_soyo: "Technical Support — Soyo",
          finance: "Administrative & Finance Department",
          job: "Human Resources · Come work with us",
          partnership: "Local Partnership",
        },
        job_notice: "To apply, please fill in the candidate form:",
        job_link: "Complete Application →",
        message: "Message",
        message_ph: "Tell us about your request…",
        submit: "Send message",
        sending: "Sending...",
        success: "Message sent. We'll get back to you shortly.",
        error: "Could not send. Please try again or call us.",
        required: "Please fill the required fields.",
      },
    },
    footer: {
      tagline:
        "An Angolan company · Telecom, IT, TV & Satellite.",
      rights: "All rights reserved.",
      nav_title: "Navigation",
      services_title: "Services",
      contact_title: "Contact",
      group_title: "TVCabsat Group Companies",
      group_dauag_desc: "Diamonds, gold and silver · Prospecting and mining",
      group_wesa_desc: "Internet at your fingertips",
    },
  },
  es: {
    nav: {
      about: "Nosotros",
      equipment: "Equipos",
      infrastructure: "Infraestructura",
      portfolio: "Portafolio",
      services: "Servicios",
      partners: "Marcas",
      whyus: "Por qué",
      contact: "Contacto",
      careers: "Carreras",
      cta: "Contáctanos",
      catalog: "Catálogo",
    },
    hero: {
      overline: "Empresa angoleña · 🇦🇴",
      title_line1: "Telecom,",
      title_line2: "Informática &",
      title_line3: "Satélite.",
      subtitle:
        "Especialistas en sistemas de Telecomunicaciones e Informática — VSAT, Wireless, TV por Cable y Satélite, Seguridad, Telefonía y redes de Datos.",
      primary_cta: "Solicitar presupuesto",
      secondary_cta: "Ver servicios",
      live_status: "Equipo técnico en servicio",
    },
    about: {
      overline: "Sobre TVCabSat",
      title: "Tecnología, fiabilidad y equipo en Angola.",
      body_1:
        "TVCABSAT, Lda es una empresa angoleña que se destaca en la oferta de soluciones avanzadas en Sistemas y Equipos de Telecomunicaciones e Informática. Con una infraestructura tecnológica robusta, estamos especializados en:",
      specialties: [
        {
          title: "Soluciones VSAT",
          desc: "Banda Ku, Banda Ka y Banda C, impulsadas por el satélite angoleño ANGOSAT-2.",
        },
        {
          title: "TV por Cable y Satélite",
          desc: "Servicios de alta calidad y fiabilidad.",
        },
        {
          title: "Equipos de Vigilancia",
          desc: "Sistemas de CCTV y seguridad para una protección eficaz.",
        },
        {
          title: "Teléfonos Satelitales y Convencionales",
          desc: "Soluciones de comunicación versátiles.",
        },
        {
          title: "Centralitas y Redes Telefónicas",
          desc: "Centralitas analógicas y digitales, además de redes de datos.",
        },
        {
          title: "Mantenimiento e Implantación de Torres de Telecomunicaciones",
          desc: "Construcción, instalación y mantenimiento de torres autoportantes, atirantadas y mástiles en todo el territorio angoleño.",
        },
      ],
      body_2:
        "Representamos y comercializamos equipos de marcas globalmente reconocidas por su fiabilidad, incluyendo radios y repetidores MOTOROLA y HYTERA, centralitas digitales y analógicas INTELBRAS, además de sistemas de recepción de televisión DSTV. Nuestro equipo está altamente capacitado para montaje y asistencia técnica, garantizando la satisfacción y seguridad de nuestros clientes.",
      clientes_title: "Clientes",
      clientes_body:
        "Entre nuestros clientes se encuentran instituciones del Estado, la Embajada de los Estados Unidos y otras del país, y empresas de servicios para petroleras en Angola. Suministramos equipos de radio UHF/VHF con certificación contra explosiones de los grupos IIA y IIC, adecuados para entornos exigentes con gases como hidrógeno y acetileno, reflejando nuestra capacidad para atender demandas exigentes y de alta complejidad.",
      stat_team: "Empleados",
      stat_team_desc: "Equipo multidisciplinar a su servicio",
      stat_years: "Años",
      stat_years_desc: "De operación en el mercado angoleño",
      stat_brands: "Marcas",
      stat_brands_desc: "Socios internacionales representados",
    },
    services: {
      overline: "Lo que hacemos",
      title: "Seis áreas. Un equipo. Ejecución integral.",
      subtitle:
        "De la ingeniería al mantenimiento, TVCabSat actúa en todas las capas de conectividad y tecnología.",
      assistance: {
        title: "Asistencia Técnica",
        desc: "Mantenimiento preventivo y correctivo para su infraestructura crítica.",
        items: [
          "Sistemas DSTV",
          "Redes de Telecomunicaciones",
          "Centralitas Telefónicas",
          "VSATs",
          "Sistemas de Informática",
        ],
      },
      television: {
        title: "Monitores HD",
        desc: "Del monitor LED/LCD al condominio — señal limpia, instalación profesional.",
        items: [
          "Venta de Monitores LED y LCD",
          "Montaje de Sistemas DSTV",
          "Distribución de señal TV en condominios",
        ],
      },
      communications: {
        title: "Comunicaciones",
        desc: "Radio, telefonía y satelital para operaciones exigentes.",
        items: [
          "Radios y Repetidores MOTOROLA",
          "Centralitas INTELBRAS y ALCATEL",
          "VSATs",
        ],
      },
      it: {
        title: "Informática",
        desc: "Redes estructuradas, wireless y computadoras — listos para producir.",
        items: [
          "Venta de computadoras",
          "Sistemas Wireless para datos e Internet",
          "Instalación de redes estructuradas",
        ],
      },
      towers: {
        title: "Torres de Telecomunicaciones",
        desc: "Instalación, construcción y mantenimiento de torres de telecomunicaciones por equipos especializados — proyecto llave en mano de 6 a 30 metros.",
        items: [
          "Instalación y construcción de torres reticuladas",
          "Mantenimiento preventivo y correctivo",
          "Mástiles galvanizados de 6m a 12m",
          "Torres autoportantes y atirantadas de 15m a 30m",
          "Bases de hormigón armado y anclajes",
        ],
      },
      security: {
        title: "Seguridad & CCTV",
        desc: "Sistemas electrónicos de monitorización — la columna vertebral de la seguridad moderna.",
        items: [
          "Cámaras analógicas e IP",
          "Reconocimiento facial y lectura de matrículas (IA)",
          "Grabación NVR / DVR continua",
          "Monitorización remota en tiempo real",
        ],
      },
    },
    partners: {
      overline: "Marcas representadas",
      title: "Equipos internacionales de fiabilidad comprobada.",
    },
    whyus: {
      overline: "Por qué TVCabSat",
      title: "Calidad, eficiencia y compromiso.",
      subtitle:
        "Con nuestro equipo de 40 empleados, buscamos ser útiles en la ejecución de cualquier contrato, actual o futuro.",
      points: [
        {
          title: "Fiabilidad",
          desc: "Marcas y procesos certificados. Soluciones que perduran.",
        },
        {
          title: "Equipo especializado",
          desc: "40 profesionales en ingeniería, instalación y soporte.",
        },
        {
          title: "Cobertura integral",
          desc: "Del proyecto al mantenimiento — un único interlocutor.",
        },
        {
          title: "Presencia nacional",
          desc: "Sede en Luanda, con capacidad de operar en todo el país.",
        },
      ],
    },
    contact: {
      overline: "Contáctanos",
      title: "Hablemos de tu contacto y del proyecto que necesitas.",
      subtitle:
        "Envíanos un mensaje o llama directamente. Respondemos en horario comercial.",
      address_label: "Dirección",
      address_value: "Rua Padre Manuel Ruela Pombo, 40 · PB y 3.º piso · Maianga · Luanda · Angola",
      phone_label: "Teléfonos Recepción",
      office_phones: "Oficina: +244 222 352 949 · +244 222 352 922",
      mobile_phone: "Móvil: +244 925 687 036",
      hours_label: "Horario",
      hours_value: "Lun — Vie · 08:00 a 17:00",
      commercial_title: "Desarrollo de Negocios",
      finance_title: "Contactos Administrativo y Finanzas",
      direction_title: "Contactos de Dirección",
      area_comercial_title: "Área Comercial",
      support_title: "Soporte Técnico",
      cta_banner_title: "Podemos ayudarle con cualquiera de sus proyectos.",
      cta_banner_desc: "Del análisis a la instalación — hable con nosotros y nuestro equipo diseña la solución adecuada para usted.",
      dopamine_title_pre: "Construyamos algo",
      dopamine_title_highlight: "extraordinario",
      dopamine_title_post: "juntos.",
      dopamine_subtitle:
        "Respuesta en menos de 24 horas hábiles · 100% garantía oficial · Cobertura nacional.",
      dopamine_call_label: "Llamar ahora",
      dopamine_email_label: "Enviar email",
      dopamine_whatsapp_label: "WhatsApp",
      dopamine_quick_links: "Enlaces rápidos",
      commercial_phone_label: "Tel.",
      commercial_email_label: "Email",
      commercial_list: [
        {
          name: "Dércio Mancoca",
          role: "Responsable de Desarrollo de Negocios",
          phone: "+244 923 269 030",
          phone_href: "+244923269030",
          phones: [
            { label: "+244 923 269 030", href: "+244923269030" },
            { label: "+244 925 687 036", href: "+244925687036" },
          ],
          emails: [
            "dercio.mancoca@tvcabsat.ao",
          ],
        },
      ],
      finance_list: [
        {
          name: "Paula Martins",
          role: "Responsable del Área Financiera",
          phone: "+244 929 100 486",
          phone_href: "+244929100486",
          emails: [
            "paula.martins@tvcabsat.ao",
            "financas@tvcabsat.ao",
          ],
        },
      ],
      direction_list: [
        {
          name: "Duarte Nuno Martins",
          role: "CEO",
          phones: [],
          emails: [
            "d.nuno@tvcabsat.ao",
            "administracao@tvcabsat.ao",
          ],
        },
      ],
      area_comercial_list: [
        {
          name: "Equipo Comercial",
          role: "Ventas y atención al cliente",
          phone: "+244 925 687 036",
          phone_href: "+244925687036",
          emails: ["comercial@tvcabsat.ao"],
        },
      ],
      support_list: [
        {
          name: "Luanda Soporte Técnico",
          role: "Soporte técnico — Luanda",
          phone: "+244 938 926 564",
          phone_href: "+244938926564",
          emails: ["suporte@tvcabsat.ao"],
        },
        {
          name: "Soyo Soporte y Comercial",
          role: "Soporte técnico y comercial — Soyo",
          phone: "+244 976 665 377/378",
          phone_href: "+244976665378",
          phones: [
            { label: "+244 976 665 377/378", href: "+244976665378" },
          ],
          emails: ["suporte@tvcabsat.ao"],
        },
      ],
      commercial_name: "Paula Martins",
      commercial_role: "Responsable del Área Comercial",
      commercial_phone: "+244 929 100 486",
      form: {
        name: "Nombre",
        name_ph: "Tu nombre",
        email: "Email",
        email_ph: "email@ejemplo.com",
        phone: "Teléfono",
        phone_ph: "923 000 000",
        phone_invalid: "Número de teléfono no válido para el país seleccionado.",
        subject: "Asunto",
        subject_ph: "Seleccione un asunto",
        subject_options: {
          commercial_luanda: "Departamento Comercial — Luanda",
          commercial_soyo: "Departamento Comercial — Soyo",
          support_luanda: "Asistencia Técnica — Luanda",
          support_soyo: "Asistencia Técnica — Soyo",
          finance: "Departamento Administrativo y Finanzas",
          job: "Recursos Humanos · Ven a trabajar con nosotros",
          partnership: "Alianza Local",
        },
        job_notice: "Para postular, completa el formulario de candidato:",
        job_link: "Completar Candidatura →",
        message: "Mensaje",
        message_ph: "Cuéntanos sobre tu solicitud…",
        submit: "Enviar mensaje",
        sending: "Enviando...",
        success: "Mensaje enviado. Te contactaremos en breve.",
        error: "No se pudo enviar. Intenta de nuevo o llámanos.",
        required: "Completa los campos obligatorios.",
      },
    },
    footer: {
      tagline:
        "Empresa angoleña · Telecom, Informática, TV & Satélite.",
      rights: "Todos los derechos reservados.",
      nav_title: "Navegación",
      services_title: "Servicios",
      contact_title: "Contacto",
      group_title: "Empresas Grupo TVCabsat",
      group_dauag_desc: "Diamantes, oro y plata · Prospección y exploración",
      group_wesa_desc: "Internet a la punta de tu dedo",
    },
  },
};
